import { motion } from 'framer-motion';
import type { CSSProperties, ReactNode } from 'react';
import { useReduceMotion } from '@/lib/useReduceMotion';

/**
 * Entrance wrapper using the exact recipe from the HeroUI v3 animation guide
 * (getting-started/animation → "Entrance animations"):
 *   initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
 * Honours prefers-reduced-motion via Framer's useReducedMotion (the guide's
 * accessibility note) — collapses to a no-op duration when motion is reduced.
 */
export function HeroFadeIn({
  children,
  y = 12,
  duration = 0.4,
  delay = 0,
  className,
  style,
}: {
  children: ReactNode;
  y?: number;
  duration?: number;
  delay?: number;
  className?: string;
  style?: CSSProperties;
}) {
  const reduce = useReduceMotion();
  return (
    <motion.div
      className={className}
      style={style}
      initial={reduce ? { opacity: 0 } : { opacity: 0, y }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: reduce ? 0 : duration, delay: reduce ? 0 : delay }}
    >
      {children}
    </motion.div>
  );
}
